module.exports = __webpack_public_path__ + "static/img/sou-s@2x.3b274e04.png";